import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
  selector: 'app-search-btn',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBtnComponent extends ButtonComponent {
  constructor() {
    super();
    this.icon = 'search';
    this.label = $localize`Szukaj`;
    this.style = 'secondary';
    this.type = 'submit';
  }
}
